export const useSiteMedia = function () {
  const deviceType = useState('deviceType');

  const DEBOUNCE_DELAY = 100;

  const defaultSizes = {
    width: {
      desktop: 1280,
      mobile: 360,
    },
  };

  const preClientValue = {
    width: typeof window !== 'undefined' ? window.innerWidth : deviceType.value === 'desktop' ? defaultSizes.width.desktop : defaultSizes.width.mobile,
  };

  const width = ref(preClientValue.width);

  let resizeTimeoutId: ReturnType<typeof setTimeout>;

  const updateDimensions = () => {
    if (typeof window !== 'undefined') {
      width.value = window.innerWidth;
    }
  };

  const debounce = (callback: () => void, delay: number, timeoutId: ReturnType<typeof setTimeout>): ReturnType<typeof setTimeout> => {
    clearTimeout(timeoutId);
    return setTimeout(callback, delay);
  };

  const onResize = () => {
    resizeTimeoutId = debounce(updateDimensions, DEBOUNCE_DELAY, resizeTimeoutId);
  };

  onMounted(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', onResize);
    }
  });

  onUnmounted(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', onResize);
    }
  });

  const isTablet = computed(() => width.value < 768);

  useState('isTablet', () => isTablet.value);

  watch(() => isTablet.value, (newVal) => {
    useState('isTablet').value = newVal;
  });
};
